import clsx from 'clsx';
import React from 'react';
import { TVisualOption } from '../../../types/options';
import { FlagIcon } from '../FlagIcon/FlagIcon';
import styles from './badge.module.css';

type TBadgeProps = {
    flagIcon?: string;
    size?: TVisualOption['size'];
    disabled?: boolean;
    defaultIcon?: string;
};

export const Badge = (props: TBadgeProps) => {
    return (
        <span className={clsx(styles.badgeContainer, styles[`${props.size}`])}>
            <FlagIcon defaultIcon={props.defaultIcon} name={props.flagIcon} size={props.size === 'medium' ? '20px' : '16px'} isDisabled={props.disabled} />
        </span>
    );
};
